import React, { useState, useRef, useEffect } from 'react';
import EditSubjectModal from '../../../Generic/EditSubjectModal';
import LcLoading from '../../../Generic/LcLoading';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../store/index';
import { MenuState } from '../../../../store/reducers/menuReducer';
import { UserState } from "../../../../store/reducers/userReducer";
import SolicitationCommentService from "../../../../services/SolicitationCommentService/SolicitationCommentService";
import SolicitationService from "../../../../services/SolicitationService/SolicitationService";
import SideModal from '../../SideModal/SideModal';
import SolicitationDetails from '../../../../pages/Solicitations/SolicitatonsList/SolicitationDetails';
import Comment from './Comment';
import { useHistory } from 'react-router-dom';
import "./index.css";
import moment from "moment";

interface Props {
    alterModalVisible: Function
    commentTypeList: number[]
}

const LastComments: React.FC<Props> = (props) => {
    const solicitationCommentService = new SolicitationCommentService(props);
    const solicitationService = new SolicitationService(props);
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const [localUrl, setLocalUrl] = useState<any>(window.location.pathname);
    const [currentComments, setCurrentComments] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itensPerPage, setItensPerPage] = useState<number>(10);
    const [comments, setComments] = useState<any>([]);
    const [refresh, setRefresh] = useState<boolean>(false);

    const ref = useRef<HTMLDivElement | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>();
    const [loadingSaveSubject, setLoadingSaveSubject] = useState<boolean>(false);
    const [modalVisibleDetails, setModalVisibleDetails] = useState<boolean>(false);
    const history = useHistory();

    useEffect(() => {
        const intersectionObserver = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                setCurrentPage((currentPegeInsideState) => currentPegeInsideState + 1);
            }
        });

        if (ref.current) intersectionObserver.observe(ref.current);

        return () => intersectionObserver.disconnect();
    }, [])

    useEffect(() => {
        paginationComments(comments);
    }, [currentPage]);

    useEffect(() => {
        if (props.commentTypeList) {
            if (!menu.showHelper) {
                getCommentByIdUser();
            }
        }
    }, [props.commentTypeList]);

    useEffect(() => {
        if (menu.showHelper) {
            const helperComments = [
                {
                    text: "teste comentario",
                    commentDate: new Date(),
                    nameUser: "João Garcia",
                    idSolicitation: "123546",
                    subjectWork: "teste assunto",
                    new: 1,
                    teamWork: "ddddd",
                    workId: "ddddd",
                },
                {
                    text: "teste comentario",
                    commentDate: moment(new Date()).subtract(1, "d"),
                    nameUser: "Paula Santos",
                    idSolicitation: "123546",
                    subjectWork: "teste assunto",
                    new: 0,
                    teamWork: "ddddd",
                    workId: "ddddd",
                },
                {
                    text: "teste comentario",
                    commentDate: moment(new Date()).subtract(4, "d"),
                    nameUser: "Ester Lis",
                    idSolicitation: "123546",
                    subjectWork: "teste assunto",
                    new: 0,
                    teamWork: "ddddd",
                    workId: "ddddd",
                }
            ];

            setCurrentComments(helperComments);
            paginationComments(helperComments);
            setComments(helperComments);
        }
    }, [menu.showHelper])

    const getCommentByIdUser = async () => {
        setRefresh(true);

        try {
            var filterCommentType = props.commentTypeList.join('_');
            paginationComments([]);
            setComments([]);

            const response: any = await solicitationCommentService.getByHistoryRequester(Number(user.id), user.attendant, filterCommentType, localUrl);
            let validComments = response.data;

            paginationComments(validComments);
            setComments(validComments);
        }
        catch (e) {
            console.log(e);
        }

        setRefresh(false);
    }

    const paginationComments = (arrayComments) => {
        const startIndex = currentPage * itensPerPage;
        const endIndex = startIndex + itensPerPage;
        setCurrentComments(() => arrayComments.slice(0, endIndex));
    }

    // const alterLoadingSaveSubject = (value: boolean) => {
    //     setLoadingSaveSubject(value);
    // }

    // const alterSelectedRow = (row: any) => {
    //     setSelectedRow(row);
    //     setModalVisibleDetails(true);
    // }

    const handleHeaderDetails = () => {
        if (selectedRow !== undefined) {
            if (selectedRow.idStatus === 8 || selectedRow.idStatus === 7) {
                return `Avaliação do atendimento - ${selectedRow.id}`;
            }
            else {
                return `${selectedRow.subject} - ${selectedRow.id}`;
            }
        }
        else return "";
    }

    const getSelectionRow = async (selectionId: number) => {
        setLoadingSaveSubject(true);

        if (user.attendant === 1 && localUrl === '/Attendance') {
            history.push(`/Attendance/${selectionId}`);
        }
        else {
            setRefresh(true);

            try {
                const response = await solicitationService.getSolicitationDetailById(selectionId);
                setSelectedRow(response.data);
            }
            catch (error) {
                console.warn(error);
            }

            setRefresh(false);
        }

        setModalVisibleDetails(true);
        // props.alterModalVisible(false);
        setLoadingSaveSubject(false);
    }

    return (
        <div className='sideComments'>
            <LcLoading loading={refresh}>
                <div className="lastComments">
                    {
                        currentComments.length > 0
                            ? <>
                                {
                                    currentComments.map(element => {
                                        return <Comment element={element} getSelectionRow={getSelectionRow} />
                                    })
                                }
                            </>
                            : <div className="centralized">
                                <i className="ppi ppi-information-circle" />
                                <span>Nenhum comentário nos últimos 30 dias</span>
                            </div>
                    }

                    <div style={{ marginBottom: "20px" }} />
                </div>
            </LcLoading>

            <div ref={ref} id="sentinela" />
            {
                selectedRow &&
                <SolicitationDetails
                    header={handleHeaderDetails()}
                    visible={modalVisibleDetails}
                    onClose={() => setModalVisibleDetails(false)}
                    solicitation={selectedRow}
                    loading={loadingSaveSubject}
                    handleCloseReopen={() => setRefresh(true)}
                />
            }
        </div>
    );
};

export default LastComments;